import React from "react"
import PropTypes from "prop-types"
// Styles
import {
   Container,
   Wrapper,
   Image,
   Text,
   Title,
} from "./PageSectionSplitHalf.styles"

const PageSectionSplitHalf = ({ image, title, text, imageFirst }) => {
   return (
      <Container>
         {imageFirst ? (
            <>
               <Image src={image} />
               <Wrapper>
                  <Title
                     dangerouslySetInnerHTML={{
                        __html: title?.replace(/\n/g, "<br />"),
                     }}
                  />
                  <Text
                     dangerouslySetInnerHTML={{
                        __html: text?.replace(/\n/g, "<br />"),
                     }}
                  />
               </Wrapper>
            </>
         ) : (
            <>
               <Wrapper>
                  <Title
                     dangerouslySetInnerHTML={{
                        __html: title?.replace(/\n/g, "<br />"),
                     }}
                  />
                  <Text
                     dangerouslySetInnerHTML={{
                        __html: text?.replace(/\n/g, "<br />"),
                     }}
                  />
               </Wrapper>
               <Image src={image} />
            </>
         )}
      </Container>
   )
}

PageSectionSplitHalf.propTypes = {
   image: PropTypes.string,
   title: PropTypes.string,
   text: PropTypes.string,
   imageFirst: PropTypes.bool,
}

export default PageSectionSplitHalf
